// src/navigation.js
let navigate;

export const setNavigator = (navFn) => {
  navigate = navFn;
};

export const getNavigator = () => {
  return navigate
};

export const goToLogin = (isLogout = false) => {
  if (navigate && isLogout) {
    // Clear both storage layers (mirrors clearAuth from helpers.js)
    // Inlined here to avoid circular dependency (helpers.js imports navigation.js)
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('selectedSport');
    sessionStorage.removeItem('selectedTeam');
    sessionStorage.removeItem('sports');
    sessionStorage.removeItem('setting');
    localStorage.removeItem('slam_user');
    localStorage.removeItem('slam_selectedSport');
    localStorage.removeItem('slam_selectedTeam');
    navigate('/login');
  }
};
